var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.792 9.67956C87.2438 13.0733 58.7391 43.9639 56.25 99.8249H111.277C111.966 80.4749 122.766 66.0092 142.875 63.8764C162.614 61.7811 181.341 66.4827 187.012 79.978C193.139 94.5561 179.386 111.497 172.847 118.608C160.744 131.794 141.084 141.412 130.894 155.639C120.905 169.58 119.128 187.922 118.359 210.37H166.856C167.536 196.017 168.492 182.269 175.022 173.348C185.644 158.855 201.506 152.062 214.8 140.615C227.498 129.675 240.858 116.489 243.127 96.0796C249.938 34.9967 200.077 6.04206 141.792 9.67956Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.041 290.625C159.951 290.625 173.659 277.124 173.659 260.47C173.659 243.816 159.951 230.315 143.041 230.315C126.13 230.315 112.422 243.816 112.422 260.47C112.422 277.124 126.13 290.625 143.041 290.625Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.d27862696246f1cc6634aeb592b5f033.svg";
export { ForwardRef as ReactComponent };